import { useState, useEffect } from 'react';
import { fetchUsers, deleteUsers } from '../../services/AdminUserService';

const useUserActions = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadUsers();
  }, []);

  useEffect(() => {
    filterUsers();
  }, [searchTerm, users]);

  const clearSelectedUsers = () => {
    const updatedUsers = filteredUsers.map((user) => ({
      ...user,
      isSelected: false
    }));
    setFilteredUsers(updatedUsers);
    setSelectedUsers([]);
  };

  const loadUsers = async () => {
    setIsLoading(true);
    try {
      const data = await fetchUsers();
      setUsers(data);
      setFilteredUsers(data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleBulkDelete = async (selectedUsers) => {
    try {
      const userIds = selectedUsers.map(user => user.id);
      await deleteUsers(userIds);
    } catch (error) {
    }
  };

  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const filterUsers = () => {
    let filtered = users;

    if (searchTerm) {
      filtered = filtered.filter(
        (user) =>
          user.id.toString().includes(searchTerm.toLowerCase()) ||
          `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredUsers(filtered);
  };

  const handleSelectAll = (isSelected) => {
    const updatedUsers = filteredUsers.map(user => ({
      ...user,
      isSelected: isSelected
    }));

    setFilteredUsers(updatedUsers);
    setSelectedUsers(isSelected ? filteredUsers : []);
  };

  const handleUserSelect = (userId, isSelected) => {
    const updatedUsers = filteredUsers.map((user) =>
      user.id === userId ? { ...user, isSelected: isSelected } : user
    );
    
    setFilteredUsers(updatedUsers);
    
    if (isSelected) {
      const selectedUser = filteredUsers.find(user => user.id === userId);
      setSelectedUsers([...selectedUsers, selectedUser]);
    } else {
      setSelectedUsers(selectedUsers.filter((user) => user.id !== userId));
    }
  };

  return {
    users,
    filteredUsers,
    selectedUsers,
    setSelectedUsers,
    loadUsers,
    handleBulkDelete,
    handleFilter,
    handleSelectAll,
    handleUserSelect,
    clearSelectedUsers,
    isLoading
  };
};

export default useUserActions;